import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'
import type { ResMembers } from '@/lib/queries/business/v1/types'

export const getMembersQuery = queryOptions<ResMembers | null>({
  queryKey: [API_ENDPOINTS.business.v1.user.members.index],
  queryFn: () => {
    return w.get(API_ENDPOINTS.business.v1.user.members.index).json()
  },
  retry: false,
})

export const getPendingMembersQuery = queryOptions<ResMembers | null>({
  queryKey: [API_ENDPOINTS.business.v1.user.members.pending.index],
  queryFn: () => {
    return w.get(API_ENDPOINTS.business.v1.user.members.pending.index).json()
  },
  retry: false,
})
